import { InputHTMLAttributes } from 'react';

import { useFormatedTextChange } from 'core/helpers/text';

export const Input: React.FC<InputHTMLAttributes<HTMLInputElement>> = props => {
  return (
    <input
      {...props}
      onKeyDown={useFormatedTextChange<HTMLInputElement>(props.onChange)}
    />
  );
};
